export default __webpack_public_path__ + "static/4---How-Do-You-Evaluate-a-UX-Designer-b39326799e075624ad5672ad90e08a03.png";